<template>
  <div class="content full">
    <div class="content_box mt10">
      <div :style="`height: 630px;`" class="map_wrap">
        <div id="map" :style="mapStyle"></div>
      </div>
    </div>
  </div>
</template>

<script>
import cargo from '@/api/rest/trans/cargo'

export default {
  name: 'CargoVesselLocationInfo',
  props: {
    blNo: {
      type: String,
      default: ''
    }
  },

  data: function () {
    return {
      containerId: 'map',
      token: 'd2c17969-5135-4401-822c-aeedc9262e2e',
      options: {
        display: ['card'],
        cardPosition: { x: 2, y: 5 },
        cardStyle: 2,
        center: { x: 125, y: 25, z: 0 },
        selectedTile: 'LIGHT',
        init: [],
        markers: [],
        vesselColor: 'SOG'
      },
      mapStyle: {
        width: '100%',
        height: '100%',
        overflow: 'hidden'
      },
      vslLocation: []
    }
  },
  async mounted () {
    await this.init()
    // Oceanlook 라이브러리가 로드되었는지 확인합니다.
    if (globalThis.Oceanlook) {
      this.initOceanlookMap()
    } else {
      console.error('Oceanlook script is not loaded or available.')
      // 필요하다면, 스크립트 로드가 완료될 때까지 기다리는 로직을 추가할 수 있습니다.
    }
  },
  methods: {
    async init () {
      await cargo.getContainerCodes(this.blNo)
        .then(res => {
          this.vslLocation = res.data
        })
    },
    // 커스텀 필드 콜백 함수
    customFieldCallback (data) {
      // Return custom fields to display in ship cards
      // ex. fetch additional data from your server based on mmsi or imoNumber
      // data -> {mmsi, imoNumber}
      console.log('customFieldCallback', data)
    },
    // Oceanlook 임베드 초기화
    initOceanlookMap () {
      console.log(this.vslLocation)
      // Oceanlook의 전역 객체에 접근
      const Oceanlook = globalThis.Oceanlook
      if (this.vslLocation !== null && this.vslLocation.length > 0) {
        this.vslLocation.forEach((vsl, idx) => {
          if (vsl.tnsKndCd !== '01') return // vessel 아니면 skip
          if (!/^\d+$/.test(vsl.imoNo)) return // imoNo가 숫자가 아니면 skip
          let info = {}
          info.imo = vsl.imoNo
          info.track = []
          let track = {
            type: 'TIME',
            mode: 'FLOW',
            color: '#000FFF'
          }
          // 부산은 .... KRBNP에코마린용신항 이거 없다..., KRPUS북항, KRPNC신항  ? pnc 로 cm011c 에서 명칭 가져오는디.....
          info.custom = []
          // C2.POL_CTR_CD || C2.POL_PORT_CD AS 우리꺼 이걸로 보여줘야 함.
          info.custom.push({ type: 'DEPT_CODE', value: vsl.polPortCd })
          info.custom.push({ type: 'DEST_CODE', value: vsl.podPortCd })
          info.custom.push({ type: 'DEPARTURE_PORT', value: vsl.polPortNm })
          info.custom.push({ type: 'DESTINATION_PORT', value: vsl.podPortNm })
          if (!this.$ekmtcCommon.isEmpty(vsl.eta) && !this.$ekmtcCommon.isEmpty(vsl.etd)) {
            track.startDate = this.convertToISOFormat(vsl.etd, vsl.polTimeDiff)
            track.endDate = this.convertToISOFormat(vsl.eta, vsl.podTimeDiff)
            // if (idx == 0)track.startDate = '2026-03-07T14:00:00Z'
            // track.endDate = '2026-06-15T15:00:00Z'
            const etdUtc = new Date(track.startDate)
            const etaUtc = new Date(track.endDate)
            const now = new Date()
            if (etdUtc > now) {
              // 미래일때 오션룩에서 오류.
              delete track.startDate
              delete track.endDate
              if (this.options.init?.length > 0) return
            }
            if (etdUtc <= now && now <= etaUtc) {
              // 미래일 경우 오류 발생
              if (etaUtc > now) track.endDate = now
              // 운항 중인 선박만 track 표시 등
              let track_future = {
                type: 'PORT',
                unlocode: vsl.podPortCdOl,
                mode: 'FLOW',
                color: '#8B5CF6'
              }
              info.track.push(track_future)
            } else if (etdUtc > now && idx === 0) {
              // 최초 선박의 미출항건 처리
              let track_future = {
                type: 'PORT',
                unlocode: vsl.polPortCdOl,
                mode: 'FLOW',
                color: '#8B5CF6'
              }
              info.track.push(track_future)
            }
          }
          // info.hide = true

          info.track.push(track)
          this.options.init.push(info)
        })
      }

      // 항구 표기
      this.vslLocation.forEach(vsl => {
        if (!['01', '02'].includes(vsl.tnsKndCd)) return // vessel 아니면 skip
        if (!this.options.markers.some(m => m.unlocode === vsl.polPortCdOl)) {
          this.options.markers.push({ unlocode: vsl.polPortCdOl, color: '#7a77ba', label: vsl.polPortCd, tooltip: vsl.polPortNm })
        }
        if (!this.options.markers.some(m => m.unlocode === vsl.podPortCdOl)) {
          this.options.markers.push({ unlocode: vsl.podPortCdOl, color: '#7a77ba', label: vsl.podPortCd, tooltip: vsl.podPortNm })
        }
      })
      console.log(this.options)
      // Custom field callback function 설정
      Oceanlook.setCustomFieldCallback(this.customFieldCallback)

      // 맵 임베드
      Oceanlook.embed(this.containerId, this.token, this.options)
    },
    convertToISOFormat (dateString, offsetHours = 9) {
      // 1. 문자열에서 각 날짜/시간 구성 요소 추출
      const year = dateString.substring(0, 4)
      const month = dateString.substring(4, 6)
      const day = dateString.substring(6, 8)
      const hour = dateString.substring(8, 10)
      const minute = dateString.substring(10, 12)
      let second = dateString.substring(12, 14)

      if (this.$ekmtcCommon.isEmpty(second)) {
        second = '00'
      }

      // offsetHours = 입력 문자열의 timezone (한국이면 +9, 인도면 +5.5).
      // 30분 단위 timezone도 지원. 해당 오프셋으로 파싱한 뒤 toISOString()으로 UTC ISO 8601로 변환한다.
      // 예) convertToISOFormat('20260523013500', 9)   -> '2026-05-22T16:35:00Z' (UTC)
      //     convertToISOFormat('20260523013500', 5.5) -> '2026-05-22T20:05:00Z' (UTC)
      const totalMin = Math.round(offsetHours * 60)
      const sign = totalMin >= 0 ? '+' : '-'
      const absMin = Math.abs(totalMin)
      const offsetHH = String(Math.floor(absMin / 60)).padStart(2, '0')
      const offsetMM = String(absMin % 60).padStart(2, '0')
      const offset = `${sign}${offsetHH}:${offsetMM}`
      const isoStringWithOffset = `${year}-${month}-${day}T${hour}:${minute}:${second}${offset}`
      const dateObject = new Date(isoStringWithOffset)
      const isoFormat = dateObject.toISOString()
      return isoFormat.replace(/\.\d{3}Z$/, 'Z')
    }
  }
}
</script>

<!--<style scoped>-->
<!--@import "../../assets/css/sol.css";-->
<!--</style>-->
